/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  MenuItem,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import { BotonIcono } from "shared/botonIcono";
import { Alerta } from "shared/alerta";
import { useRequisicion } from "hooks/useRequisicion";
import RequisicionModulo from "./../components/VistaModulos/RequisicionModulo";
import { FormikProvider } from "formik";
import SearchIcon from "@mui/icons-material/Search";
import DetallesRequisicion from "components/VistaModulos/DetallesRequisicion";
import CotizacionModal from "components/VistaModulos/Cotizacion";
import BitacoraRequisicion from "components/VistaModulos/BitacoraRequisicion";
import Autocomplete from "@mui/material/Autocomplete";
import {
  IconUserEdit,
  IconPlaylistAdd,
  IconShoppingBagPlus,
  IconDownload,
  IconDeviceDesktopSearch,
  IconTimeline,
  IconRepeat,
  IconEye,
  IconAlertTriangle,
  IconBug,
  IconBrandWhatsapp,
  IconBrandTelegram,
  IconCheckbox,
  IconPhoneOff,
} from "@tabler/icons-react";
import { MuiFileInput } from "mui-file-input";
import {
  FilaProductoCantidad,
  obtenerIdProducto,
  ProductoSeleccionadoModulo,
} from "modules/productoSeleccionado";
import { resumirProductoEnDetalles } from "modules/productoSeleccionado/utils/productoSeleccionado.utils";
import { BotonReportarProblema } from "modules/reporteProblemas";
import { InventarioTabla, InventarioDetalleContenido } from "modules/inventario";
import { GestionCotizacionContenido } from "modules/gestionCotizacion";

function Requisicion(): JSX.Element {
  const fotoUser: any = useSelector((state: StoreType) => state?.app?.user?.data?.foto || logo);
  const nombreAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.nombre || null
  );
  const apellidosAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.apellidos || null
  );
  const telEmpresa = useSelector(
    (state: StoreType) => state?.app?.user?.data?.tel_empresa ?? ""
  );
  const sinTelEmpresa = !String(telEmpresa).trim();
  const nombreCompletoAutorizando = nombreAutorizando + " " + apellidosAutorizando;

  const {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    requisiciones,
    //crear requisicion
    isAlertOpenCrearRequisicion,
    handleisAlertCrearRequisicionOpen,
    handleisAlertCrearRequisicionClose,
    getFieldColor,
    createRequisicion,
    requisicionesPaginadas,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    handleBuscadorChange,
    visualizacion,
    handleVisualizacion,
    idUsuario,
    usuarios,
    tipoProductos,
    categorias,
    // productos
    detalles,
    handleRemoveDetalle,
    // modal producto
    productoSearch,
    productosFiltrados,
    //paginacion de productos de inventario
    pageProductos,
    rowsPerPageProductos,
    handleChangePageProductos,
    handleChangeRowsPerPageProductos,
    handleProductoSearchChange,
    productosPaginadosModal,
    //ver detalles de la requisicion
    isAlertOpenDetalleRequisicion,
    handleisAlertOpenDetalleRequisicion,
    handleisAlertCloseDetalleRequisicion,
    verDetalleRequisicion,
    setVerDetalleRequisicion,
    //cotizacion
    procesandoCotizacion,
    //autorizar
    enviarAutorizar,
    procesoAutorizacion,
    accionRequisicion,
    handleAccionRequisicion,
    getJefeInmediato,
    jefeInmediato,
    setAccionRequisicion,
    //detalles cotización
    verCotizacion,
    setVerCotizacion,
    isAlertOpenCotizacion,
    handleisAlertOpenCotizacion,
    handleisAlertCloseCotizacion,
    proveedoresPorProducto,
    procesandoProveedores,
    getProveedoresPorProductos,
    surtirDisponible,
    handleCambioCotizacion,
    cotizacionLista,
    enviarCotizacion,
    //mostrar bitacora de requisicion
    getBitacoraRequisicionPorId,
    bitacora,
    setBitacora,
    isAlertOpenBitacora,
    handleisAlertOpenBitacora,
    handleisAlertCloseBitacora,
    empresas,
    //imagen referencia
    handleChangeImagen,
    setImagenReferencia,
    imagenReferencia,
    //crear producto nuevo
    procesandoInventario,
    isAlertOpenCrearInventario,
    handleisAlertCrearInventarioOpen,
    handleisAlertCrearInventarioClose,
    formikInventario,
    getFieldColorInventario,
    unidadesMedida,
    ubicaciones,
    almacenes,
    createInventarioOnRequi,
    procesandoModal,
    setIdDetalleRequisicion,
    idDetalleRequisicion,
    //lista seleccionable de productos
    isAlertOpenListaSeleccionable,
    handleisAlertOpenListaSeleccionable,
    handleisAlertCloseListaSeleccionable,
    filasInventario,
    setProductoDetalle,
    productoDetalle,
    actualizarProductoEnRequisicion,
    errorImagen,
    cancelarRequisicion,
    procesandoEnModal,
    //editar requisiciones
    modoEdicion,
    idRequisicionEditar,
    imagenReferenciaActual,
    handleEditarRequisicion,
    reabrirRequisicion,
    urlImagenReferencia,
    isModalImagenOpen,
    handleOpenModalImagen,
    handleCloseModalImagen,
    urlVerImagenReferencia,
    handleAgregarLinea,
    handleCambiarCantidadLinea,
    handleCambiarObservacionesLinea,
    marcarProductoAtendido,
    lineasSinComentario,
    botonRequisicionDeshabilitado,
    countProductosSeleccionados,
    totalPedidoTexto,
    proyectos,
    cambiarProyectoRequisicion,
    cambiarEmpresaRequisicion,
    reportarProblema,
    proveedores,
    getRequisicionPorId,
    cargandoDetalle,
    userName,
    puedeMarcarAtendida,
    handleMarcarAtendida,
    //gestion de cotizaciones
    gestion,
    filasInventarioSeleccionables,
  } = useRequisicion();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
            >
              <Grid xs={12}>
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  Requisición
                </Typography>
              </Grid>
              <Grid xs={12}>
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                  Crear nueva requisición de compra
                </Typography>
              </Grid>

              {idUsuario > 0 && sinTelEmpresa && (
                <Grid xs={6} sx={{ my: 1.5 }}>
                  <Alerta
                    tipo="warning"
                    compacta
                    icono={<IconPhoneOff size={18} stroke={2} />}
                    titulo="Teléfono de empresa no registrado"
                    texto="No recibirás las notificaciones por WhatsApp de tus requisiciones. Favor de reportarlo a FH."
                    accion={
                      <BotonIcono
                        icono={<IconBrandWhatsapp size={18} stroke={2} />}
                        textoUno="Reportar"
                        textoDos="a FH"
                        colorTexto="#fff"
                        fondoBoton="#128C7E"
                        fondoHover="#0b776b"
                        degradado
                        disabled={procesandoEnModal}
                        onClick={() =>
                          reportarProblema({
                            id_usuario: idUsuario,
                            problema: `El usuario ${nombreCompletoAutorizando} (id ${idUsuario}) no tiene tel_empresa registrado y no recibe notificaciones de WhatsApp.`,
                          })
                        }
                      />
                    }
                  />
                </Grid>
              )}

              <Grid xs={12}>
                <RequisicionModulo
                  verRequisiciones={requisiciones}
                  requisicionesPaginadas={requisicionesPaginadas}
                  visualizacion={visualizacion}
                  handleVisualizacion={handleVisualizacion}
                  procesando={procesando}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  buscador={buscador}
                  handleBuscadorChange={handleBuscadorChange}
                  handleisAlertCrearRequisicionOpen={handleisAlertCrearRequisicionOpen}
                  handleisAlertOpenDetalleRequisicion={handleisAlertOpenDetalleRequisicion}
                  setVerDetalleRequisicion={setVerDetalleRequisicion}
                  getJefeInmediato={getJefeInmediato}
                  getBitacoraRequisicionPorId={getBitacoraRequisicionPorId}
                  handleisAlertOpenBitacora={handleisAlertOpenBitacora}
                  getRequisicionPorId={getRequisicionPorId}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      {/* MODAL PARA AÑADIR NUEVA REQUISICIÓN */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCrearRequisicionClose}
        isOpen={isAlertOpenCrearRequisicion}
        key={"alerta-crear-Requisicion"}
        procesando={procesandoModal}
        textoHeader={modoEdicion ? "Editar Requisición" : "Nueva Requisición"}
        textoFooter={detalles.length > 0 && countProductosSeleccionados + " · " + totalPedidoTexto}
        actions={[
          {
            title: modoEdicion
              ? intl.formatMessage({ id: "general_reabrir_requisicion" })
              : intl.formatMessage({ id: "general_añadir_requisicion" }),
            icon: modoEdicion ? <IconRepeat stroke={2} /> : <IconShoppingBagPlus stroke={2} />,
            color: "#D4AF37",
            hoverColor: "#a98c2c",
            textColor: "#3D3E3D",
            disabledButton: botonRequisicionDeshabilitado,
            handleAction: () => {
              const datosBase = {
                id_usuario: formik.values.id_usuario,
                id_empresa: formik.values.id_empresa,
                extras: formik.values.extras,
                imagen_referencia: imagenReferencia,
                detalles,
              };

              if (modoEdicion) {
                reabrirRequisicion({
                  ...datosBase,
                  id_requisicion: idRequisicionEditar,
                  id_editor: idUsuario,
                });
              } else {
                createRequisicion({ ...datosBase, id_creador: idUsuario });
              }
            },
          },
        ]}
      >
        <FormikProvider value={formik!}>
          <Grid container spacing={2} mt={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} sm={3} sx={{ display: "flex", alignItems: "end" }}>
              <Autocomplete
                id="id_usuario"
                fullWidth
                options={usuarios || []}
                disabled={!usuarios || usuarios.length === 0}
                getOptionLabel={(option) =>
                  `${option.nombre} ${option.apellidos} | ${option.proyecto}`
                }
                isOptionEqualToValue={(option, value) => option.id_usuario === value.id_usuario}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                  "& .MuiAutocomplete-input": {
                    paddingTop: "4px !important",
                    paddingBottom: "4px !important",
                  },
                }}
                value={usuarios?.find((u) => u.id_usuario === formik.values.id_usuario) || null}
                onChange={(_, newValue) => {
                  formik.setFieldValue("id_usuario", newValue ? newValue.id_usuario : "");
                }}
                onBlur={formik.handleBlur}
                noOptionsText={intl.formatMessage({ id: "general_sin_registros" })}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={`${intl.formatMessage({ id: "select_usuario" })} *`}
                    helperText={
                      !usuarios || usuarios.length === 0
                        ? intl.formatMessage({ id: "no_hay_datos_registrados" })
                        : formik.touched.id_usuario && formik.errors.id_usuario
                    }
                    error={formik.touched.id_usuario && Boolean(formik.errors.id_usuario)}
                    sx={{
                      "& .MuiInputLabel-root": { color: getFieldColor("id_usuario") },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: getFieldColor("id_usuario"),
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: getFieldColor("id_usuario"),
                      },
                      "& .MuiInputBase-input": { color: getFieldColor("id_usuario") },
                    }}
                  />
                )}
              />
              <BotonReportarProblema
                textoHover={intl.formatMessage({ id: "reportar_problema_datos" })}
                colorFondo="#128C7E"
                colorFondoHover="#0b776b"
                deshabilitado={procesandoEnModal}
                icono={<IconBrandWhatsapp stroke={2} size={32} />}
                onEnviar={(comentario) =>
                  reportarProblema({
                    id_usuario: idUsuario,
                    problema: comentario,
                  })
                }
              />
            </Grid>
            <Grid item xs={6} sm={2} sx={{ display: "flex", alignItems: "end" }}>
              <Autocomplete
                id="id_empresa"
                fullWidth
                options={empresas || []}
                disabled={!empresas || empresas.length === 0}
                getOptionLabel={(option) => `${option.nombre}`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                  "& .MuiAutocomplete-input": {
                    paddingTop: "4px !important",
                    paddingBottom: "4px !important",
                  },
                }}
                value={empresas?.find((u) => u.id === formik.values.id_empresa) || null}
                onChange={(_, newValue) => {
                  formik.setFieldValue("id_empresa", newValue ? newValue.id : "");
                }}
                onBlur={() => formik.setFieldTouched("id_empresa", true)}
                noOptionsText={intl.formatMessage({ id: "general_sin_registros" })}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={`${intl.formatMessage({ id: "select_empresa" })} *`}
                    helperText={
                      !empresas || empresas.length === 0
                        ? intl.formatMessage({ id: "no_hay_datos_registrados" })
                        : formik.touched.id_empresa && formik.errors.id_empresa
                    }
                    error={formik.touched.id_empresa && Boolean(formik.errors.id_empresa)}
                    sx={{
                      "& .MuiInputLabel-root": { color: getFieldColor("id_empresa") },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: getFieldColor("id_empresa"),
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: getFieldColor("id_empresa"),
                      },
                      "& .MuiInputBase-input": { color: getFieldColor("id_empresa") },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "end" }}>
              <Autocomplete
                id="id_tipo_producto"
                fullWidth
                options={tipoProductos || []}
                disabled={!tipoProductos || tipoProductos.length === 0}
                getOptionLabel={(option) => `${option.nombre}`}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                  },
                  "& .MuiAutocomplete-input": {
                    paddingTop: "4px !important",
                    paddingBottom: "4px !important",
                  },
                }}
                value={tipoProductos?.find((u) => u.id === formik.values.id_tipo_producto) || null}
                onChange={(_, newValue) => {
                  formik.setFieldValue("id_tipo_producto", newValue ? newValue.id : "");
                }}
                onBlur={() => formik.setFieldTouched("id_tipo_producto", true)}
                noOptionsText={intl.formatMessage({ id: "general_sin_registros" })}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={`${intl.formatMessage({ id: "select_tipo_producto" })} *`}
                    helperText={
                      !tipoProductos || tipoProductos.length === 0
                        ? intl.formatMessage({ id: "no_hay_datos_registrados" })
                        : formik.touched.id_tipo_producto && formik.errors.id_tipo_producto
                    }
                    error={
                      formik.touched.id_tipo_producto && Boolean(formik.errors.id_tipo_producto)
                    }
                    sx={{
                      "& .MuiInputLabel-root": { color: getFieldColor("id_tipo_producto") },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: getFieldColor("id_tipo_producto"),
                      },
                      "& .MuiInput-underline:before": {
                        borderBottomColor: getFieldColor("id_tipo_producto"),
                      },
                      "& .MuiInputBase-input": { color: getFieldColor("id_tipo_producto") },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={modoEdicion && imagenReferenciaActual && !imagenReferencia ? 2 : 2}
              sx={{ display: "flex", alignItems: "end" }}
            >
              <TextField
                id="extras"
                fullWidth
                label={`${intl.formatMessage({ id: "input_referencias" })}`}
                variant="outlined"
                name="extras"
                value={formik.values.extras || ""}
                helperText={formik.touched.extras && formik.errors.extras}
                error={formik.touched.extras && Boolean(formik.errors.extras)}
                onChange={(e) => {
                  const value = e.target.value;
                  formik.setFieldValue("extras", value);
                }}
                onBlur={formik.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColor("extras"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColor("extras"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColor("extras"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColor("extras"),
                  },
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12} md={2} display="flex" justifyContent="center" alignItems="end">
              <MuiFileInput
                value={imagenReferencia}
                onChange={handleChangeImagen}
                inputProps={{ accept: "image/png, image/jpeg, image/webp, image/avif" }}
                error={Boolean(errorImagen)}
                helperText={errorImagen}
                placeholder={`${intl.formatMessage({
                  id: "subir_imagen_referencia_placeholder",
                })}`}
              />
            </Grid>
            {modoEdicion && imagenReferenciaActual && !imagenReferencia ? (
              <Grid item xs={12} sm={1}>
                <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                    Imagen referencia actual
                  </Typography>
                  <IconEye
                    stroke={2}
                    onClick={handleOpenModalImagen}
                    style={{ cursor: "pointer" }}
                  />
                </Box>
              </Grid>
            ) : null}

            <Grid item xs={12} mt={2}>
              <Typography variant="h5" color="primary" sx={{ color: "#041d45" }} gutterBottom>
                Añadir producto
              </Typography>
            </Grid>

            {/* Botón abrir modal producto */}
            <Grid item xs={12} sm={4} sx={{ display: "flex", justifyContent: "center" }}>
              {formik.values.id_tipo_producto && (
                <Grid container spacing={2}>
                  {/* Buscador */}
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Buscar producto..."
                      variant="outlined"
                      value={productoSearch}
                      onChange={(e) => handleProductoSearchChange(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  {/* Lista de productos paginada */}
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1 }}>
                      {productosPaginadosModal.length > 0 ? (
                        productosPaginadosModal
                          .filter((p: any) => p.estatus == 1)
                          .map((p: any) => {
                            const { lineas, cantidadTotal } = resumirProductoEnDetalles(
                              detalles,
                              p
                            );
                            return (
                              <FilaProductoCantidad
                                key={obtenerIdProducto(p)}
                                producto={p}
                                lineas={lineas}
                                onAgregar={handleAgregarLinea}
                              />
                            );
                          })
                      ) : (
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ p: 2, textAlign: "center" }}
                        >
                          Sin resultados
                        </Typography>
                      )}

                      {/* Paginación */}
                      <MDBox
                        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <TablePagination
                          component="div"
                          count={productosFiltrados.length}
                          page={pageProductos}
                          onPageChange={handleChangePageProductos}
                          rowsPerPage={rowsPerPageProductos}
                          onRowsPerPageChange={handleChangeRowsPerPageProductos}
                          rowsPerPageOptions={[3, 6, 9, 12]}
                          labelRowsPerPage="Por página:"
                          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                          sx={{
                            ".MuiTablePagination-toolbar": {
                              justifyContent: "space-between",
                              padding: "8px 16px",
                            },
                            ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
                              margin: 0,
                            },
                            ".MuiTablePagination-actions svg": { transform: "scaleX(-1)" },
                          }}
                        />
                      </MDBox>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>

            {/* Tabla de productos añadidos */}
            {detalles.length > 0 && (
              <Grid item xs={12} sm={8}>
                {lineasSinComentario > 0 && (
                  <Alert severity="warning" sx={{ mb: 1, textAlign: "left" }}>
                    {lineasSinComentario === 1
                      ? "1 producto requiere comentario antes de guardar."
                      : `${lineasSinComentario} productos requieren comentario antes de guardar.`}
                  </Alert>
                )}
                <ProductoSeleccionadoModulo
                  detalles={detalles}
                  ocultarTotal
                  handleRemoveDetalle={handleRemoveDetalle}
                  onCambiarCantidadLinea={handleCambiarCantidadLinea}
                  onCambiarObservacionesLinea={handleCambiarObservacionesLinea}
                />
              </Grid>
            )}
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* MODAL PARA VER DETALLES DE LA REQUISICION */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseDetalleRequisicion}
        isOpen={isAlertOpenDetalleRequisicion}
        key={"alerta-detalles"}
        procesando={procesandoEnModal}
        textoHeader={cargandoDetalle ? "" : `Requisición ${verDetalleRequisicion?.folio}`}
        textoFooter={
          <BotonReportarProblema
            texto={intl.formatMessage({ id: "reportar_problema_datos" })}
            deshabilitado={procesandoEnModal}
            onEnviar={(comentario) =>
              reportarProblema({
                id_usuario: idUsuario,
                problema: comentario,
              })
            }
          />
        }
        actions={[
          ...(puedeMarcarAtendida
            ? [
              {
                title: procesandoEnModal
                  ? "Cargando..."
                  : intl.formatMessage({ id: "general_marcar_atendida" }),
                icon: <IconCheckbox stroke={2} />,
                color: "#3ec972",
                hoverColor: "#269951",
                textColor: "#fff",
                disabledButton:
                  procesandoEnModal || verDetalleRequisicion?.estatus_requisicion === 6,
                handleAction: handleMarcarAtendida,
              },
            ]
            : []),
          {
            title: "Ver bitácora",
            icon: <IconTimeline stroke={2} />,
            color: "#71bcff",
            textColor: "#072e51",
            hoverColor: "#599ad4",
            disabledButton: cargandoDetalle,
            handleAction: () => {
              if (!verDetalleRequisicion) return;
              getBitacoraRequisicionPorId({ id_requisicion: verDetalleRequisicion.id });
              handleisAlertOpenBitacora();
            },
          },
        ]}
      >

        {cargandoDetalle ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "50vh",
              gap: 2,
            }}
          >
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">
              {intl.formatMessage({ id: "general_cargando_datos" })}
            </Typography>
          </Box>
        ) : (
          verDetalleRequisicion && (
            <DetallesRequisicion
              verRequisicion={verDetalleRequisicion}
              procesandoCotizacion={procesandoCotizacion}
              enviarAutorizar={enviarAutorizar}
              usuarioArjion={userName}
              procesoAutorizacion={procesoAutorizacion}
              idUsuario={idUsuario}
              accionRequisicion={accionRequisicion}
              handleAccionRequisicion={handleAccionRequisicion}
              jefeInmediato={jefeInmediato}
              nombreCompletoAutorizando={nombreCompletoAutorizando}
              setAccionRequisicion={setAccionRequisicion}
              handleisAlertOpenCotizacion={handleisAlertOpenCotizacion}
              setVerCotizacion={setVerCotizacion}
              surtirDisponible={surtirDisponible}
              handleisAlertCrearInventarioOpen={handleisAlertCrearInventarioOpen}
              setIdDetalleRequisicion={setIdDetalleRequisicion}
              cancelarRequisicion={cancelarRequisicion}
              handleEditarRequisicion={handleEditarRequisicion}
              isModalImagenOpen={isModalImagenOpen}
              handleOpenModalImagen={handleOpenModalImagen}
              handleCloseModalImagen={handleCloseModalImagen}
              urlVerImagenReferencia={urlVerImagenReferencia}
              marcarProductoAtendido={marcarProductoAtendido}
              proyectos={proyectos}
              empresas={empresas}
              cambiarProyectoRequisicion={cambiarProyectoRequisicion}
              cambiarEmpresaRequisicion={cambiarEmpresaRequisicion}
            />
          ))}
      </ModalComponent>
      {/* MODAL PARA VER IMAGEN REFERENCIA A TAMAÑO ORIGINAL */}
      <ModalComponent
        handleClose={handleCloseModalImagen}
        isOpen={isModalImagenOpen}
        key="vista-imagen-referencia"
        titleButtonAction="Descargar imagen"
        colorAction="#40ad80"
        hoverColorAction="#338a66"
        iconButtonAction={<IconDownload stroke={2} />}
        handleAction={() => {
          if (!urlVerImagenReferencia) return;

          const link = document.createElement("a");
          link.href = urlVerImagenReferencia;
          link.download = verDetalleRequisicion?.imagen_referencia || "imagen_referencia";
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        {urlVerImagenReferencia && (
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ maxHeight: "80vh", overflow: "auto" }}
              >
                <Box
                  component="img"
                  src={urlVerImagenReferencia}
                  alt="Imagen de referencia"
                  sx={{
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA VER LA BITÁCORA DE LA REQUISICIÓN */}
      <ModalComponent
        handleClose={handleisAlertCloseBitacora}
        isOpen={isAlertOpenBitacora}
        key={"alerta-bitacora"}
        {...(verDetalleRequisicion
          ? {
            actions: [
              {
                title: "Ver requisición",
                icon: <IconDeviceDesktopSearch stroke={2} />,
                color: "#71bcff",
                textColor: "#072e51",
                hoverColor: "#599ad4",
                handleAction: () => {
                  const datos = {
                    id_usuario_creador: verDetalleRequisicion?.id_creador,
                    id_requisicion: verDetalleRequisicion?.id,
                  };
                  getJefeInmediato(datos);
                  handleisAlertCloseBitacora();
                  handleisAlertOpenDetalleRequisicion();
                },
              },
            ],
          }
          : {})}
      >
        {bitacora && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <BitacoraRequisicion bitacora={bitacora} procesando={procesando} />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA COTIZAR */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseCotizacion}
        isOpen={isAlertOpenCotizacion}
        key={"alerta-detalles-cotizacion"}
        procesando={procesandoCotizacion || gestion.procesando}
        textoHeader={
          !verCotizacion?.cotizacion
            ? `Crear nueva cotización para requisición ${verCotizacion?.folio}`
            : `Cotización #${gestion.cotizacion?.id ?? ""} — Requisición ${verCotizacion?.folio}`
        }
        actions={
          !verCotizacion?.cotizacion
            ? [
              {
                title: "Enviar cotización",
                icon: <IconBrandTelegram stroke={2} />,
                color: "#dec162",
                hoverColor: "#826f30",
                textColor: "#000",
                disabledButton: !cotizacionLista || procesandoCotizacion,
                handleAction: enviarCotizacion,
              },
            ]
            : gestion.acciones
        }
      >
        {!verCotizacion?.cotizacion ? (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <CotizacionModal
                verCotizacion={verCotizacion}
                procesandoCotizacion={procesandoCotizacion}
                usuarioArjion={userName}
                idUsuario={idUsuario}
                proveedores={proveedores}
                nombreCompletoAutorizando={nombreCompletoAutorizando}
                proveedoresPorProducto={proveedoresPorProducto}
                procesandoProveedores={procesandoProveedores}
                getProveedoresPorProductos={getProveedoresPorProductos}
                onCambioCotizacion={handleCambioCotizacion}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} mt={2}>
              <GestionCotizacionContenido gestion={gestion} />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA AÑADIR PRODUCTO NUEVO */}
      <ModalComponent
        handleClose={handleisAlertCrearInventarioClose}
        isOpen={isAlertOpenCrearInventario}
        key={"alerta-crear-Inventario"}
        procesando={procesandoModal}
        actions={[
          {
            title: "Añadir producto",
            icon: <IconShoppingBagPlus stroke={2} />,
            color: "#D4AF37",
            hoverColor: "#a98c2c",
            textColor: "#3D3E3D",
            disabledButton: !formikInventario.isValid || procesandoModal,
            handleAction: () => {
              const datos = {
                clave: formikInventario.values.clave,
                nombre: formikInventario.values.nombre,
                precio: formikInventario.values.precio,
                id_unidad_medida: formikInventario.values.id_unidad_medida,
                id_categoria: formikInventario.values.id_categoria,
                id_ubicacion: formikInventario.values.id_ubicacion,
                id_tipo_producto: formikInventario.values.id_tipo_producto,
                cantidad: formikInventario.values.cantidad,
                maximos: formikInventario.values.maximos,
                minimos: formikInventario.values.minimos,
                punto_reorden: formikInventario.values.punto_reorden,
                id_usuario: idUsuario,
                id_requisicion_detalle: idDetalleRequisicion,
              };
              createInventarioOnRequi(datos);
            },
          },
          {
            title: "Seleccionar existente",
            icon: <IconPlaylistAdd stroke={2} />,
            color: "#87CEEB",
            hoverColor: "#6ca4bc",
            textColor: "#041d45",
            handleAction: () => {
              handleisAlertOpenListaSeleccionable();
            },
          },
        ]}
      >
        <FormikProvider value={formikInventario!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography
                variant="h5"
                color="primary"
                gutterBottom
                sx={{ color: "#004c93", textAlign: "center" }}
              >
                Registrar Producto
              </Typography>
            </Grid>
            <br />
            <Grid item xs={6} sm={6}>
              <TextField
                id="clave"
                fullWidth
                label={`${intl.formatMessage({ id: "input_clave" })}`}
                variant="standard"
                name="clave"
                value={formikInventario.values.clave || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("clave", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.clave && Boolean(formikInventario.errors.clave)}
                helperText={formikInventario.touched.clave && formikInventario.errors.clave}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("clave"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("clave"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("clave"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("clave"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre" })}`}
                variant="standard"
                name="nombre"
                value={formikInventario.values.nombre || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("nombre", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.nombre && Boolean(formikInventario.errors.nombre)}
                helperText={formikInventario.touched.nombre && formikInventario.errors.nombre}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("nombre"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="precio"
                fullWidth
                label={`${intl.formatMessage({ id: "input_precio" })}`}
                variant="standard"
                name="precio"
                type="number"
                value={formikInventario.values.precio || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("precio", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.precio && Boolean(formikInventario.errors.precio)}
                helperText={formikInventario.touched.precio && formikInventario.errors.precio}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("precio"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("precio"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("precio"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("precio"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_unidad_medida"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_unidad_medida" })} *`}
                variant="standard"
                name="id_unidad_medida"
                value={formikInventario.values.id_unidad_medida || ""}
                disabled={!unidadesMedida || unidadesMedida.length === 0}
                helperText={
                  !unidadesMedida || unidadesMedida.length === 0
                    ? intl.formatMessage({ id: "sin_unidades_medida_registradas" })
                    : formikInventario.touched.id_unidad_medida &&
                    formikInventario.errors.id_unidad_medida
                }
                error={
                  formikInventario.touched.id_unidad_medida &&
                  Boolean(formikInventario.errors.id_unidad_medida)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_unidad_medida", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_unidad_medida"),
                  },
                }}
              >
                {unidadesMedida?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_categoria"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_categoria" })} *`}
                variant="standard"
                name="id_categoria"
                value={formikInventario.values.id_categoria || ""}
                disabled={!categorias || categorias.length === 0}
                helperText={
                  !categorias || categorias.length === 0
                    ? intl.formatMessage({ id: "sin_categorias_registradas" })
                    : formikInventario.touched.id_categoria && formikInventario.errors.id_categoria
                }
                error={
                  formikInventario.touched.id_categoria &&
                  Boolean(formikInventario.errors.id_categoria)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_categoria", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_categoria"),
                  },
                }}
              >
                {categorias?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_ubicacion"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_ubicacion" })} *`}
                variant="standard"
                name="id_ubicacion"
                value={formikInventario.values.id_ubicacion || ""}
                disabled={!ubicaciones || ubicaciones.length === 0}
                helperText={
                  !ubicaciones || ubicaciones.length === 0
                    ? intl.formatMessage({ id: "sin_ubicaciones_registradas" })
                    : formikInventario.touched.id_ubicacion && formikInventario.errors.id_ubicacion
                }
                error={
                  formikInventario.touched.id_ubicacion &&
                  Boolean(formikInventario.errors.id_ubicacion)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_ubicacion", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_ubicacion"),
                  },
                }}
              >
                {ubicaciones?.map((option) => (
                  <MenuItem key={option.id_ubicacion} value={option.id_ubicacion}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_tipo_producto"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_tipo_producto" })} *`}
                variant="standard"
                name="id_tipo_producto"
                value={formikInventario.values.id_tipo_producto || ""}
                disabled={!tipoProductos || tipoProductos.length === 0}
                helperText={
                  !tipoProductos || tipoProductos.length === 0
                    ? intl.formatMessage({ id: "sin_tipos_producto_registrados" })
                    : formikInventario.touched.id_tipo_producto &&
                    formikInventario.errors.id_tipo_producto
                }
                error={
                  formikInventario.touched.id_tipo_producto &&
                  Boolean(formikInventario.errors.id_tipo_producto)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_tipo_producto", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_tipo_producto"),
                  },
                }}
              >
                {tipoProductos?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="cantidad"
                fullWidth
                label={`${intl.formatMessage({ id: "input_cantidad" })}`}
                variant="standard"
                name="cantidad"
                type="number"
                value={formikInventario.values.cantidad || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("cantidad", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={
                  formikInventario.touched.cantidad && Boolean(formikInventario.errors.cantidad)
                }
                helperText={formikInventario.touched.cantidad && formikInventario.errors.cantidad}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("cantidad"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="maximos"
                fullWidth
                label={`${intl.formatMessage({ id: "input_maximos" })}`}
                variant="standard"
                name="maximos"
                type="number"
                value={formikInventario.values.maximos || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("maximos", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.maximos && Boolean(formikInventario.errors.maximos)}
                helperText={formikInventario.touched.maximos && formikInventario.errors.maximos}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("maximos"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="minimos"
                fullWidth
                label={`${intl.formatMessage({ id: "input_minimos" })}`}
                variant="standard"
                name="minimos"
                type="number"
                value={formikInventario.values.minimos || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("minimos", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.minimos && Boolean(formikInventario.errors.minimos)}
                helperText={formikInventario.touched.minimos && formikInventario.errors.minimos}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("minimos"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="punto_reorden"
                fullWidth
                label={`${intl.formatMessage({ id: "input_punto_reorden" })}`}
                variant="standard"
                name="punto_reorden"
                type="number"
                value={formikInventario.values.punto_reorden || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("punto_reorden", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={
                  formikInventario.touched.punto_reorden &&
                  Boolean(formikInventario.errors.punto_reorden)
                }
                helperText={
                  formikInventario.touched.punto_reorden && formikInventario.errors.punto_reorden
                }
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("punto_reorden"),
                  },
                }}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* LISTA DE PRODUCTOS EXISTENTES */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseListaSeleccionable}
        isOpen={isAlertOpenListaSeleccionable}
        key={"alerta-lista-seleccionable"}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12} md={12} mt={2}>
            <Typography
              variant="h4"
              color="primary"
              gutterBottom
              sx={{ color: "#004c93", textAlign: "center" }}
            >
              Lista de productos existentes
            </Typography>
            <Typography variant="button" gutterBottom sx={{ color: "#00", textAlign: "center" }}>
              Selecciona el producto que quieras registrar a la requisición
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InventarioTabla
              filas={filasInventarioSeleccionables}
              cargando={procesando}
              mostrarEstatus
              busqueda
              onVerDetalle={setProductoDetalle}
              mensajeVacio={intl.formatMessage({ id: "general_sin_registros" })}
            />
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL DE DETALLE DE PRODUCTO */}
      <ModalComponent
        handleClose={() => setProductoDetalle(null)}
        isOpen={productoDetalle !== null}
        key={"alerta-detalle-producto"}
        actions={[
          {
            title: "Actualizar producto",
            icon: <IconUserEdit stroke={2} />,
            color: "#0047AB",
            hoverColor: "#003a8c",
            textColor: "#ffffff",
            handleAction: async () => {
              if (!productoDetalle) return;
              const exito = await actualizarProductoEnRequisicion(productoDetalle);
              if (exito) setProductoDetalle(null);
            },
          },
        ]}
      >
        {productoDetalle && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} mt={2}>
              <Typography variant="h5" color="primary" gutterBottom sx={{ color: "#004c93" }}>
                {productoDetalle.nombre}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <InventarioDetalleContenido fila={productoDetalle} />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default Requisicion;
